import React from 'react';
import { LockIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
type SectionCTAProps = {
  label: string;
  note?: string;
  dark?: boolean;
  id?: string;
};
export function SectionCTA({
  label,
  note = 'Instant access · One-time payment · 7-day money-back guarantee',
  dark = false,
  id
}: SectionCTAProps) {
  return <div className="mt-12 flex flex-col items-center text-center" data-id="element-319" data-mp="1qa3bsrlo8big">
      <CTAButton label={label} id={id} data-id="element-320" data-mp="1blyy621h6q6j" />
      <p className={`mt-4 flex items-center justify-center gap-1.5 text-[13px] font-medium ${dark ? 'text-slate-300' : 'text-slate-500'}`} data-id="element-321" data-mp="1bkxfbbe7wze9">
        <LockIcon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-322" data-mp="12nwsvaaplbdg" />
        <span data-id="element-323" data-mp="17kn49kbkjisj">{note}</span>
      </p>
    </div>;
}